export const settings = {
	COLLECTIONS_URL: '/wp-json/fsd/v1/wp/video-collections/',
	MPX_PLAYLIST_URL: '/wp-json/fsd/v1/wp/mpx-related-videos'
};

export const global = {
	FSGO_URL: 'https://www.foxsportsgo.com/',
};

export const widthRange = {
	DESKTOP: '1280+',
	LAPTOP: '1024-1279',
	TABLET: '768-1023',
	MOBILE: '-767',

	DESKTOP_MOBILE: '-767,1280+',
	TABLET_LAPTOP: '768-1279'
};

export const shareLinks = {
	FB_SHARE: 'https://www.facebook.com/sharer/sharer.php?u=',
	TWITTER_SHARE: 'https://twitter.com/intent/tweet?url=',
	GOOGLE_PLUS: 'https://plus.google.com/share?url=',
	MAIL: 'mailto:?subject='
};



// WEBPACK FOOTER //
// ./react-app-src/shared/constants.js